import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import { captureException } from '@sentry/react';
import { ErrorState } from './error-state/ErrorState';
import { useTranslation } from 'contexts/translation-context';

const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  const { i18n } = useTranslation();

  return (
    <ErrorState error={error} onRetry={resetErrorBoundary} retryLabel={i18n('errors.reloadPage')} variant="section" />
  );
};

export const SimpleErrorBoundary: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(err) => {
        captureException(err);
      }}
      onReset={() => {
        // eslint-disable-next-line no-restricted-globals
        window.location.reload();
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
